import { _k } from "../kaplay";

export function dt() {
    return _k.app.dt();
}

export function fixedDt() {
    return _k.app.fixedDt();
}

export function restDt() {
    return _k.app.restDt();
}
